const Items = [
  {
    id: 0,
    name: "모래성 장난감",
    price: 25000,
    imgUrl: "./item_images/toy_sandCastle.png",
    description: "노즈워크를 위한 장난감입니다.",
    category: "toy",
    class: "A",
    detailUrl: "./item_images/toy_sandCastle_detail.png",
    quantity: 1,
  },
  {
    id: 1,
    name: "호박 쿠키",
    price: 5000,
    imgUrl: "./item_images/food_pumkinCookie.png",
    description: "다이어트와 변비에 좋은 비타민A가 가득한 펌킨쿠키",
    category: "food",
    class: "A",
    detailUrl: "./item_images/food_pumkinCookie_detail.png",
    quantity: 1,
  },
  {
    id: 2,
    name: "소프트 틈새 케어 칫솔",
    price: 7300,
    imgUrl: "./item_images/bath_toothBrush.png",
    description: "1만 개의 부드러운 칫솔모로 구석구석 깨끗하게",
    category: "bath",
    class: "A",
    detailUrl: "./item_images/bath_toothBrush_detail.png",
    quantity: 1,
  },
  {
    id: 3,
    name: "말랑 고구마",
    price: 6500,
    imgUrl: "./item_images/food_sweetPotato.png",
    description: "국산 고구마로 만든 고담백 간식 말랑 고구마",
    category: "food",
    class: "A",
    detailUrl: "./item_images/food_sweetPotato_detail.png",
    quantity: 1,
  },
  {
    id: 4,
    name: "이지클린 드라이 샴푸",
    price: 18500,
    imgUrl: "./item_images/bath_dryShampoo.png",
    description: "죽었던 컬이 살아난다! 물없이 샴푸하는 초간편 샴푸",
    category: "bath",
    class: "B",
    detailUrl: "./item_images/bath_dryShampoo_detail.png",
    quantity: 1,
  },
  {
    id: 5,
    name: "소고기 육포",
    price: 23000,
    imgUrl: "./item_images/food_beefJerky.png",
    description: "고단백 저지방 간식, 고소하고 담백한 소고기 육포",
    category: "food",
    class: "B",
    detailUrl: "./item_images/food_beefJerky_detail.png",
    quantity: 1,
  },
  {
    id: 6,
    name: "댕댕이 치킨맥주 세트",
    price: 18900,
    imgUrl: "./item_images/toy_chickenBeer.png",
    description:
      "강아지들도 즐길 자격이 있다! 우리만 즐겼던 치킨과 맥주 댕댕이도 즐기면 얼마나 좋게요~?",
    category: "toy",
    class: "B",
    detailUrl: "./item_images/toy_chickenBeer_detail.png",
    quantity: 1,
  },
  {
    id: 7,
    name: "푸우 극세사 샤워 가운",
    price: 42000,
    imgUrl: "./item_images/clothes_pooCloth.png",
    description: "흡수력 최강! 귀염 뽀짝! 더블 레이어 극세사 샤워가운 입니다!",
    category: "clothes",
    class: "B",
    detailUrl: "./item_images/clothes_pooCloth_detail.png",
    quantity: 1,
  },
  {
    id: 8,
    name: "LED 라이트",
    price: 13000,
    imgUrl: "./item_images/accessary_ledLight.png",
    description: "메탈 소재의 튼튼한 카리비너 방식으로 체결된 LED 라이트!",
    category: "accessary",
    class: "C",
    detailUrl: "./item_images/accessary_ledLight_detail.png",
    quantity: 1,
  },
  {
    id: 9,
    name: "피글렛 극세사 샤워 가운",
    price: 42000,
    imgUrl: "./item_images/clothes_pigletCloth.png",
    description:
      "일반 극세사 가운이 아닌 흡수력을 강화한 더블 레이어 극세사 샤워가운!",
    category: "clothes",
    class: "C",
    detailUrl: "./item_images/clothes_pigletCloth_detail.png",
    quantity: 1,
  },
  {
    id: 10,
    name: "반려견 안전벨트",
    price: 20000,
    imgUrl: "./item_images/accessary_safeBelt.png",
    description: "길이는 짧아지고 더 튼튼해진 반려견 안전벨트",
    category: "accessary",
    class: "C",
    detailUrl: "./item_images/accessary_safeBelt_detail.png",
    quantity: 1,
  },
  {
    id: 11,
    name: "후라이드 치킨",
    price: 17000,
    imgUrl: "./item_images/food_friedChicken.png",
    description: "닭 가슴살과 코코넛이 만나 치느님이 되었어요!",
    category: "food",
    class: "C",
    detailUrl: "./item_images/food_friedChicken_detail.png",
    quantity: 1,
  },
  {
    id: 12,
    name: "프리미엄 김밥",
    price: 7000,
    imgUrl: "./item_images/food_gimbab.png",
    description: "영양이 한줄에 가득한 고단백 프리미엄 김밥!",
    category: "food",
    detailUrl: "./item_images/food_gimbab_detail.png",
    quantity: 1,
  },
  {
    id: 13,
    name: "블루베리 아이스크림",
    price: 21000,
    imgUrl: "./item_images/food_blueberryIceCream.png",
    description: "시원하게 즐기는 새콤달콤 블루베리 아이스크림",
    category: "food",
    detailUrl: "./item_images/food_blueberryIceCream_detail.png",
    quantity: 1,
  },
  {
    id: 14,
    name: "반숙 계란 삑삑 토이",
    price: 32000,
    imgUrl: "./item_images/toy_egg.png",
    description: "이것은 계란인가 장난감인가, 역대급 기획!",
    category: "toy",
    detailUrl: "./item_images/toy_egg_detail.png",
    quantity: 1,
  },
  {
    id: 15,
    name: "센텔라 크림",
    price: 16000,
    imgUrl: "./item_images/bath_cream.png",
    description: "손상되고 건조한 피부에 빠른 회복이 필요할 때 필수 아이템",
    category: "bath",
    detailUrl: "./item_images/bath_cream_detail.png",
    quantity: 1,
  },
  {
    id: 16,
    name: "닭가슴살 육포",
    price: 12300,
    imgUrl: "./item_images/food_chickenBreast.png",
    description: "건강한 단백질로 가득찬 살코기, 단백한 닭가슴살 육포",
    category: "food",
    detailUrl: "./item_images/food_chickenBreast_detail.png",
    quantity: 1,
  },
  {
    id: 17,
    name: "먼지괴물 소탕작전",
    price: 17500,
    imgUrl: "./item_images/toy_dustMonster.png",
    description: "먼지괴물 물리칠 용감한 멍멍이들 모여라!",
    category: "toy",
    detailUrl: "./item_images/toy_dustMonster_detail.png",
    quantity: 1,
  },
  {
    id: 18,
    name: "NO 인식표",
    price: 7000,
    imgUrl: "./item_images/accessary_noSign.png",
    description:
      "낯선사람을 무서워하거나, 컨디션이 좋지 않아 만지는 것을 싫어하는 아이들에게 어울리는 펫티켓 아이템",
    category: "accessary",
    detailUrl: "./item_images/accessary_noSign_detail.png",
    quantity: 1,
  },
  {
    id: 19,
    name: "로즈제라늄 아웃도어 스프레이",
    price: 7500,
    imgUrl: "./item_images/bath_outdoorSpray.png",
    description:
      "동물에겐 좋은 향이지만 진드기는 기피하는 로즈제라늄 아웃도어 스프레이!",
    category: "bath",
    detailUrl: "./item_images/bath_outdoorSpray_detail.png",
    quantity: 1,
  },
  {
    id: 20,
    name: "기능성 우비 (방풍/투습)",
    price: 27000,
    imgUrl: "./item_images/clothes_waterproof.png",
    description: "비가오나 눈이오나 누구도 내 산책을 막을 수 없어!",
    category: "clothes",
    detailUrl: "./item_images/clothes_waterproof_detail.png",
    quantity: 1,
  },
];

export default Items;
